module.exports = __webpack_public_path__ + "bc47ecb7f9d871faedf4f5652ff6963f.jpeg";